import React, { Component } from 'react';

import { allowPermission, setCapitalPage } from 'actions/capital';
import { connect } from 'react-redux';
import * as clevertapCapital from 'clevertap/capital';
import { CAPITAL_DENIED_PERMISSION_PAGE } from 'utils/capitalUtils';
import styles from './PermissionSharing.css';

class PermissionSharing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { sendingRequest } = nextProps;
    this.setState({ clicked: sendingRequest });
  }

  render() {
    const { sendingRequest } = this.props;
    const mokaCapitalLogo =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/moka-capital-logo.png';
    return (
      <div className={`row ${styles['body-container']}`}>
        <div className={`row ${styles['row-padding']}`}>
          <div className={`col-sm-5 col-lg-4 ${styles['box-permission']}`}>
            <div className={`col-md-12`}>
              <img src={mokaCapitalLogo} className={`img-responsive`} />
            </div>
            <div className={`col-md-12 text-center`}>
              <h3 className={styles['capital-title']}>&nbsp;</h3>
            </div>
            <div className={`col-md-12`}>
              <p>
                <b>Moka Capital</b> is requesting permission to share the
                following with our lending partners:
              </p>
            </div>
            <div className={`col-md-12`}>
              <ul>
                <li className={`${styles['disc-li']}`}>
                  <b>Business Profile</b>
                </li>
                <li>Access your Business Profile</li>
                <li className={`${styles['disc-li']}`}>
                  <b>Transaction Data</b>
                </li>
                <li>Access your Transaction Data</li>
                <li className={`${styles['disc-li']}`}>
                  <b>Report Data</b>
                </li>
                <li>Access your Report Data</li>
                <li className={`${styles['disc-li']}`}>
                  <b>Library Data</b>
                </li>
                <li>Access your Library Data</li>
              </ul>
            </div>
            <div className={`col-md-12`}>
              <br />
              <a
                className={`btn ${styles['allow-button']}`}
                disabled={sendingRequest}
                onClick={this._onClickAllow}
              >
                Allow
              </a>
              <a
                className={`btn ${styles['cancel-button']}`}
                onClick={this._onClickDenied}
              >
                Cancel
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickDenied = () => {
    const { dispatch } = this.props;
    dispatch(setCapitalPage(CAPITAL_DENIED_PERMISSION_PAGE));
    clevertapCapital.capitalClickCancel();
  };

  _onClickAllow = () => {
    const { dispatch } = this.props;
    if (!this.state.clicked) {
      this.setState({ clicked: true });
      dispatch(allowPermission());
      clevertapCapital.capitalClickAllow();
    }
  };
}

function mapStateToProps(state) {
  const { borrowerProfile, sendingRequest } = state.capital;
  return {
    borrowerProfile,
    sendingRequest,
  };
}

export default connect(mapStateToProps)(PermissionSharing);
